import HTTP from '../HTTP';

const URL_BASE = 'gescom/Lettrage/';

export async function sauvegarde(paramLettrage) {
  const response = await HTTP.post(URL_BASE + 'SauvegardeAsync', paramLettrage);
  return response;
}

export async function getByMouvementClient(id) {
  const response = await HTTP.get(URL_BASE + 'GetByMouvementClientAsync', { params: { id: id } });
  return response;
}

export async function getLettragesWithFacturesForCommissions(lettragesIds) {
  const response = await HTTP.post(URL_BASE + 'PGetLettragesForCommissionsAsync', lettragesIds);
  return response;
}
